import React from 'react';
import Grid from '@mui/material/Grid';
import { useDispatch, useSelector } from 'react-redux';
import DropdownFormInput from '../../../../../common/Forms/DropdownForm';
import { setRegion } from '../../../../../../redux/organization/organizationTabs/organizationRegion/organizationRegionSlice';

const RegionForm = (props) => {
  const { control, defaultValue, register } = props;
  const dispatch = useDispatch();

  const organizationReferenceData = useSelector(
    (state) => state.organizationReferenceData
  );
  const { regionList } = organizationReferenceData;

  return (
    <>
      <Grid container spacing={2} style={{ marginTop: '0px' }}>
        <Grid item xs={12} sm={4}>
          <DropdownFormInput
            name='region'
            control={control}
            options={regionList}
            defaultId={defaultValue?.region}
            region={true}
            label='Region'
            register={register('region', {
              onChange: (e) => dispatch(setRegion(e.target.value)),
            })}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default RegionForm;
